module.exports = __webpack_public_path__ + "static/media/background.c34f21e2.jpg";